import {
  configureStore,
  ThunkAction,
  Action,
  combineReducers,
  AnyAction,
  CombinedState,
} from "@reduxjs/toolkit";
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import loginReducer, { LoginState } from "../features/login/loginSlice";
import customization, {
  CustomizationState,
} from "../features/customization/customizationSlice";
import commonReducer, { CommonState } from "../features/common/commonSlice";
import magicFormsReducer, {
  MagicFormsState,
} from "../features/services/magicforms/magicFormsSlice";
import firmaReducer, {
  FirmaState,
} from "../features/services/firma/firmaSlice";
import coreIdReducer, {
  CoreIdState,
} from "../features/services/coreid/coreIdSlice";
import alertsReducer, {
  AlertsState,
} from "../features/services/alerts/alertsSlice";
import generalReducer, {
  GeneralState,
} from "../features/services/components/GeneralSlice";
import firmaNewReducer, {
  FirmaNewState,
} from "../features/services/firmanew/firmaNewSlice";
import hyperFlowReducer, {
  HyperFlowState,
} from "../features/services/hyperFlow/hyperFlowSlice";
import busquedaReducer, {
  BusquedaState,
} from "../features/services/components/BusquedaSlice";
import smartFlowReducer, {
  SmartFlowState,
} from "../features/services/smartflow/smartFlowSlice";
import pagareReducer, {
  PagareState,
} from "../features/services/pagares/pagareSlice";
import storage from "redux-persist/lib/storage";
import { persistStore } from "redux-persist";

const reducers = combineReducers({
  login: loginReducer,
  customize: customization,
  common: commonReducer,
  magicForms: magicFormsReducer,
  firma: firmaReducer,
  firmaNew: firmaNewReducer,
  coreId: coreIdReducer,
  busqueda: busquedaReducer,
  alerts: alertsReducer,
  hyperFlow: hyperFlowReducer,
  general: generalReducer,
  smartFlow: smartFlowReducer,
  pagare: pagareReducer,
});

const rootReducer = (
  state:
    | CombinedState<{
        login: LoginState;
        customize: CustomizationState;
        common: CommonState;
        magicForms: MagicFormsState;
        firma: FirmaState;
        firmaNew: FirmaNewState;
        coreId: CoreIdState;
        busqueda: BusquedaState;
        alerts: AlertsState;
        hyperFlow: HyperFlowState;
        general: GeneralState;
        smartFlow: SmartFlowState;
        pagare: PagareState;
      }>
    | undefined,
  action: AnyAction
) => {
  if (action.type === "common/resetState") {
    state = undefined;
  }

  return reducers(state, action);
};

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist: ["common", "firmaNew"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export let persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
